import {BigId, ImageURL} from '@colonist/types'
import {UserReportReasonEnum} from './general'
import {TranslationObject} from '@colonist/i18n'
import {GameAction} from './actions'
import {ActionState, PlayerColor} from '@colonist/game-states'

export interface SelectPlayerFormat {
    cancelButtonActive: boolean
    playersToSelect: PlayerColor[]
    allowableActionState: ActionState
}

export interface SelectPlayerRobberFormat extends SelectPlayerFormat {
    isPirate: boolean
}

export interface PopupInformation {
    imagePath: ImageURL
    title: TranslationObject
    body: TranslationObject
}

export interface ReportPlayer {
    reason: UserReportReasonEnum
    reportedUsername: string
}

export interface ActionStatus {
    canTakeAction: boolean
    errorMessageIfCantTakeAction?: TranslationObject
    validHoverLocations?: number[]
}

export enum GameStatisticsCategoryEnum {
    DiceRoll7 = 1,
    TimeElapsed = 2,
    InitialPipCount = 3,
    ResourcesGainedThroughDiceRolls = 4,
    NumberOfTurnsPlayerDiscarded = 5,
    RobbingIncome = 6,
    TurnsTileWasCoveredByRobber = 7,
    IncomeBlocked = 8,
    RobbingLoss = 9,
    ExpectedResourceProduction = 10,
    ExpectedNumberOfResourcesBlockedByRobber = 11,
    AFKKickCount = 12,
}

export interface PlayerGameStatisticsData {
    userId: BigId | undefined
    playerColor: PlayerColor
    category: GameStatisticsCategoryEnum
    value: number
}

export interface PlayerGameTurnStatisticsData {
    userId: BigId | undefined
    playerColor: PlayerColor
    amountOfTimeTaken: number
    numberOfActionRequests: number
    numberOfActionsCompleted: number
    turnNumber: number
}

export interface BeginnerHintFormat {
    readonly type: GameAction
    readonly data: any
}
